import { Instance, types as t } from 'mobx-state-tree';
import { ListeningTestSection } from '../../../question-data-model/TestSection/_implementations/listening-test-section.store';
import { ResultTestSectionStore } from '../result-test-section.store';

const AudioManager = t
  .model('AudioManager', {
    startTimeInSeconds: t.maybeNull(t.number),
    endTimeInSeconds: t.maybeNull(t.number),
    progressInSeconds: t.number,
  })
  .actions((self) => ({
    playRange(startTimeInSeconds?: number, endTimeInSeconds?: number) {
      self.startTimeInSeconds = startTimeInSeconds;
      self.endTimeInSeconds = endTimeInSeconds;
      self.progressInSeconds = startTimeInSeconds;
    },
    play() {
      self.endTimeInSeconds = null;
    },
    progress(progressInSeconds: number) {
      self.startTimeInSeconds = null;
      self.progressInSeconds = progressInSeconds;
    },
  }));

export const ResultListeningTestSection = t
  .compose(ListeningTestSection, ResultTestSectionStore)
  .named('ResultReadingTestSection')
  .props({
    audioManager: t.optional(AudioManager, {
      startTimeInSeconds: null,
      endTimeInSeconds: null,
      progressInSeconds: 0,
    }),
  });

export interface ResultListeningTestSectionInstance
  extends Instance<typeof ResultListeningTestSection> {}
